const DEFAULT_API_URL = "https://ai-service-cahw.onrender.com";

export type WidgetPosition =
  | "bottom-right"
  | "bottom-left"
  | "top-right"
  | "top-left"
  | "right-center";

const VALID_POSITIONS: WidgetPosition[] = [
  "bottom-right",
  "bottom-left",
  "top-right",
  "top-left",
  "right-center",
];

export interface WidgetConfig {
  tenantId: string | null;
  agentId: string;
  apiUrl: string;
  /** Explicit per-embed override — undefined means "use the agent's dashboard setting". */
  position?: WidgetPosition;
}

export function findOwnScriptTag(): HTMLScriptElement | null {
  if (document.currentScript instanceof HTMLScriptElement) {
    return document.currentScript;
  }
  const scripts = document.querySelectorAll<HTMLScriptElement>("script[data-agent-id]");
  return scripts.length > 0 ? scripts[scripts.length - 1] : null;
}

export function readConfig(tag: HTMLScriptElement | null): WidgetConfig {
  const agentId = tag?.dataset.agentId;
  if (!agentId) {
    throw new Error(
      "Artis widget: missing data-agent-id on the <script> tag that loaded it.",
    );
  }
  const rawPosition = tag?.dataset.position;
  const position = VALID_POSITIONS.includes(rawPosition as WidgetPosition)
    ? (rawPosition as WidgetPosition)
    : undefined;
  return {
    tenantId: tag?.dataset.tenantId ?? null,
    agentId,
    apiUrl: tag?.dataset.apiUrl || DEFAULT_API_URL,
    position,
  };
}
